import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Icons } from '../../../shared/helpers/icons';
import { CommonModule } from '@angular/common';
import { LucideAngularModule } from 'lucide-angular';
import { PopupMessageComponent } from '../popup-message/popup-message.component';

@Component({
  selector: 'tip-modal',
  standalone: true,
  imports: [
    CommonModule,
    LucideAngularModule,
    PopupMessageComponent
  ],
  templateUrl: './tip-modal.component.html',
  styleUrl: './tip-modal.component.css'
})
export class TipModalComponent {
  icons = Icons;
  @Input() tips: any[] = [];
  @Output() close = new EventEmitter<void>();
  @Output() selectTip = new EventEmitter<{ summary: string, id: number }>();

  messageModal: string | null = null;
  popupMessage: string | null = null;
  loading = false;

  onCloseClick(): void {
    this.close.emit();
  }

  resetMessageModal() {
    this.messageModal = null;
    this.popupMessage = null;
  }
}
